// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"mind-map"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M3 10H9V14H3V10Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M15 3H21V7H15V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M15 17H21V21H15V17Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15 5H10C7.79086 5 6 6.79086 6 9V10M15 19H10C7.79086 19 6 17.2091 6 15V14M6 14H9V10H6M6 14H3V10H6M15 3H21V7H15V3ZM15 17H21V21H15V17Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-mind-map')
export default class MindMapIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mind-map',
    }
  }
}
